/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Standalone_TitleInputs */

const cs_social_standalone_title = /** @type {(inputs: Social_Standalone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samostatný příspěvek`)
};

const en_social_standalone_title = /** @type {(inputs: Social_Standalone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standalone post`)
};

/**
* | output |
* | --- |
* | "Standalone post" |
*
* @param {Social_Standalone_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_standalone_title = /** @type {((inputs?: Social_Standalone_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Standalone_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_standalone_title(inputs)
	return cs_social_standalone_title(inputs)
});